<div class="section-news" *ngIf="hasNews" (click)="newsLinkClicked()">
    <div [innerHTML]="currentNews | safe:'html'"></div>
</div>